// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2O01a","button":"styles__button___1xt5N","modal":"styles__modal___3FWsY","overlay":"styles__overlay___Yr5Fa"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/sent-message-panel/styles.css
// module id = 1103
// module chunks = 0